export enum ClientName {
  HEALTH = 'health',
  CAR = 'car',
  BIKE = 'bike',
  LIFE = 'life',
  TRAVEL = 'travel',
  ACKO_DRIVE = 'ackodrive',
  ACKO_DRIVE_SERVICE = 'ackodriveservice',
}
